var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isLoading ? _c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _c('div', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "9",
      "lg": "7"
    }
  }, [_c('b-card', {
    staticClass: "mb-4 d-none d-md-block"
  }, [_c('b-card-title', [_vm._v("METADATA")]), _c('b-table-simple', {
    attrs: {
      "small": ""
    }
  }, [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "250px"
    }
  }), _c('col')]), _c('tbody', [_c('tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Aangemaakt op:")]), _c('td', [_vm._v(_vm._s(_vm._f("datetime")(_vm.batch.created_at)))])], 1), _c('tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Type:")]), _c('td', [_vm._v(_vm._s(_vm.batch.type.display_name))])], 1), _c('tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Status:")]), _vm.isStatusEditable ? _c('td', {
    staticClass: "py-0"
  }, [_c('b-select', {
    staticStyle: {
      "margin-top": "2px"
    },
    attrs: {
      "size": "sm",
      "options": _vm.selectableStatuses
    },
    on: {
      "input": _vm.saveBatch
    },
    model: {
      value: _vm.batch.status,
      callback: function ($$v) {
        _vm.$set(_vm.batch, "status", $$v);
      },
      expression: "batch.status"
    }
  })], 1) : _c('td', [_vm._v(_vm._s(_vm.dispatchRequestBatchStatuses[_vm.batch.status]))])], 1), _c('tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Dispatcher:")]), _c('td', [_c('location-link', {
    attrs: {
      "location": _vm.batch.dispatcher
    }
  })], 1)], 1), _c('tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Dispatch-datum:")]), _c('td', [_vm.batch.dispatch_date !== '0000-00-00' ? _c('span', [_vm._v(_vm._s(_vm._f("date")(_vm.batch.dispatch_date)))]) : _vm._e()])], 1), _vm.isSortable ? _c('tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Sorteerzone:")]), _c('td', [_vm._v(" " + _vm._s(_vm.currentSortingZone.display_name) + " "), !_vm.currentSortingZone.id && _vm.hasPermission('orders.batch.process.sort') && _vm.isFeatureEnabled('batching') ? _c('b-button', {
    staticClass: "p-0",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function ($event) {
        _vm.showSelectedSortingZoneModal = !_vm.showSelectedSortingZoneModal;
      }
    }
  }, [_c('span', [_vm._v("Maak een keuze")])]) : _vm._e(), _c('b-modal', {
    attrs: {
      "title": "Kies sorteerzone",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    on: {
      "ok": _vm.saveSortingZone
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function (_ref) {
        var cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Annuleren")]), _c('b-button', {
          attrs: {
            "variant": "success",
            "disabled": !_vm.selectedSortingZone || _vm.isSaving
          },
          on: {
            "click": _vm.saveSortingZone
          }
        }, [!_vm.isSaving ? _c('span', [_vm._v("Opslaan")]) : _c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })], 1)];
      }
    }], null, false, 2170537573),
    model: {
      value: _vm.showSelectedSortingZoneModal,
      callback: function ($$v) {
        _vm.showSelectedSortingZoneModal = $$v;
      },
      expression: "showSelectedSortingZoneModal"
    }
  }, [_c('b-select', {
    attrs: {
      "options": _vm.sortingZones,
      "text-field": "display_name",
      "value-field": "identifier"
    },
    model: {
      value: _vm.selectedSortingZone,
      callback: function ($$v) {
        _vm.selectedSortingZone = $$v;
      },
      expression: "selectedSortingZone"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm.isSortable ? _c('tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Picklijst")]), !_vm.currentSortingZone.id && _vm.isFeatureEnabled('batching') ? _c('td', [_c('span', {
    staticClass: "text-secondary"
  }, [_vm._v("Kies eerst een sorteerzone")])]) : _c('td', [_c('b-button', {
    staticClass: "p-0",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function ($event) {
        _vm.showGeneratePickListModal = !_vm.showGeneratePickListModal;
      }
    }
  }, [_vm._v(" Genereer picklijst ")]), _c('b-modal', {
    attrs: {
      "title": "Genereer picklijst",
      "centered": "",
      "dialog-class": "shadow-none"
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function (_ref2) {
        var cancel = _ref2.cancel;
        return [_c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("Annuleren")]), _c('b-button', {
          attrs: {
            "variant": "success",
            "disabled": _vm.isSaving
          },
          on: {
            "click": _vm.generatePickList
          }
        }, [!_vm.isSaving ? _c('span', [_vm._v("Genereer")]) : _c('font-awesome-icon', {
          attrs: {
            "icon": "spinner",
            "spin": ""
          }
        })], 1)];
      }
    }], null, false, 230367443),
    model: {
      value: _vm.showGeneratePickListModal,
      callback: function ($$v) {
        _vm.showGeneratePickListModal = $$v;
      },
      expression: "showGeneratePickListModal"
    }
  }, [_c('b-table-simple', [_c('colgroup', [_c('col', {
    staticStyle: {
      "width": "200px"
    }
  }), _c('col')]), _c('b-tbody', [_c('b-tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Sorteervolgorde")]), _c('b-td', [_c('b-select', {
    attrs: {
      "options": _vm.PICKLIST_SORT_ORDERS
    },
    model: {
      value: _vm.picklistForm.sortOrder,
      callback: function ($$v) {
        _vm.$set(_vm.picklistForm, "sortOrder", $$v);
      },
      expression: "picklistForm.sortOrder"
    }
  })], 1)], 1), _c('b-tr', [_c('b-th', {
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("Bestandsformaat")]), _c('b-td', [_c('b-select', {
    attrs: {
      "options": _vm.PICKLIST_CONTENT_TYPE
    },
    model: {
      value: _vm.picklistForm.contentType,
      callback: function ($$v) {
        _vm.$set(_vm.picklistForm, "contentType", $$v);
      },
      expression: "picklistForm.contentType"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e()])])], 1)], 1), _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "12",
      "md": "3",
      "lg": "5"
    }
  }, [!_vm.isSortable && (_vm.batch.status === 'created' || _vm.isSaving) ? _c('b-button', {
    staticClass: "mb-4 mr-2",
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.closeBatch
    }
  }, [_vm._v(" Batch sluiten ")]) : _vm._e(), _vm.isSortable && _vm.currentSortingZone.id && _vm.batch.status !== 'closed' && _vm.batch.status !== 'shipped' ? _c('b-button', {
    staticClass: "bg-midnight-bloom text-white mb-4",
    attrs: {
      "to": _vm.getScanRoute('sort')
    }
  }, [_vm._v(" Start met scannen ")]) : _vm._e()], 1)], 1), _c('b-card', [_c('b-card-title', [_vm._v("ORDERS")]), _c('order-list', {
    attrs: {
      "columns": _vm.orderListColumns,
      "filters": _vm.orderListFilters
    }
  })], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }